var agent = {
    text1:"REGISTRO DE AGENTE",
    badge: "Registro de agente",
    intro:
      "Para registrarte como agente, primero identifica tu agencia y selecciónala. Si todavía no aparece en el sistema, puedes crearla aquí mismo y continuar enseguida con tu registro.",
    step1: "Busca tu agencia por nombre o crea una nueva si hace falta.",
    step2: "Confirma los datos de la agencia seleccionada.",
    step3: "Completa tu información personal para activar tu acceso.",
    alternateFlowPrefix: "Si quien se va a registrar es la agencia y no un agente, usa",
    alternateFlowSuffix: "ahora.",
    searchHelper:
      "Busca la agencia del agente y selecciónala. Si todavía no existe, puedes crearla aquí para continuar con este registro.",
    searchButtonText: "Registrar agencia",
    searchButtonTitle: "Registrar agencia",
    search: {
      label: "Paso 1. Busca tu agencia",
      placeholder: "Escribe el nombre de la agencia...",
      helperText:
        "Busca la agencia del agente y selecciónala. Si todavía no existe, puedes crearla aquí para continuar con este registro.",
      buttonText: "Registrar agencia",
      buttonTitle: "Registrar agencia",
      clearSearchAria: "Limpiar búsqueda",
      panelHeader: "Resultados de búsqueda",
      loading: "Buscando agencias...",
      selectBadge: "Seleccionar",
      addressLabel: "Dirección:",
      phoneLabel: "Teléfono:",
      emptyTitle: "No encontramos agencias",
      emptyTextPrefix: "No hay coincidencias para",
      emptyTextSuffix: "Puedes registrar una nueva agencia.",
      emptyActionButtonText: "Registrar nueva agencia",
      emptyStateText: "Escribe para comenzar a buscar."
    },
    selectedAgency: {
      emptyTitle: "Aún no has seleccionado una agencia",
      emptyText:
        "Cuando elijas una, aquí verás sus datos antes de continuar con tu registro como agente.",
      titlePrefix: "Agencia seleccionada:",
      clearButton: "Limpiar",
      addressLabel: "Dirección:",
      phoneLabel: "Teléfono:",
      unavailable: "No disponible",
      noName: "Sin nombre"
    },
    form: {
      waitingAgencyMessage:
        "Paso 2. Selecciona o crea una agencia para habilitar el formulario de registro.",
      title: "Paso 2. Completa tus datos",
      subtitle:
        "Ingresa la información del agente para finalizar el registro y activar el acceso.",
      success: "Registro enviado correctamente.",
      requiredFieldsError: "Por favor completa todos los campos.",
      passwordMismatchError: "Las contraseñas no coinciden.",
      termsError: "Debes aceptar los términos y condiciones.",
      policiesError: "Debes aceptar el Aviso de Privacidad y la Política de Cookies.",
      submitError: "Ocurrió un error al enviar el formulario.",
      fullNameLabel: "Nombre completo",
      fullNamePlaceholder: "Escribe tu nombre completo",
      emailLabel: "Correo electrónico",
      emailPlaceholder: "ejemplo@correo.com",
      phoneLabel: "Teléfono",
      phonePlaceholder: "Tu número de teléfono",
      cityLabel: "Ciudad",
      cityPlaceholder: "Tu ciudad",
      agencyLabel: "Agencia / Empresa",
      agencyPlaceholder: "Agencia seleccionada",
      passwordLabel: "Contraseña",
      passwordPlaceholder: "********",
      confirmPasswordLabel: "Confirmar contraseña",
      confirmPasswordPlaceholder: "********",
      termsTextBefore: "He leído y acepto los términos y condiciones para el uso del ",
      termsLinkText: "material multimedia de Marival Resorts",
      termsTextAfter: ".",
      policiesTextBefore: "He leído y acepto los términos del ",
      policiesPrivacyLink: "Aviso de Privacidad",
      policiesTextMiddle: " y la ",
      policiesCookieLink: "Política de Cookies",
      policiesTextAfter: ".",
      submitting: "Enviando...",
      submitButton: "Crear cuenta"
    }
}
module.exports = agent
